import { render, staticRenderFns } from "./advancesDetails.vue?vue&type=template&id=e5b11900&scoped=true"
import script from "./advancesDetails.vue?vue&type=script&lang=js"
export * from "./advancesDetails.vue?vue&type=script&lang=js"
import style0 from "./advancesDetails.vue?vue&type=style&index=0&id=e5b11900&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5b11900",
  null
  
)

export default component.exports